import { render, staticRenderFns } from "./b-dropdown-flat.vue?vue&type=template&id=002bce94&scoped=true"
import script from "./b-dropdown-flat.vue?vue&type=script&lang=js"
export * from "./b-dropdown-flat.vue?vue&type=script&lang=js"
import style0 from "./b-dropdown-flat.vue?vue&type=style&index=0&id=002bce94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002bce94",
  null
  
)

export default component.exports